<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                实时库存管理
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    通过“时鲜管理”系统，中央厨房能够实时监控原材料的库存情况，包括新鲜度、保质期和库存量。
                                    这样可以确保使用的原材料始终处于最佳状态，提高食品的整体质量。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                过期预警与处理
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    系统能够自动提示即将过期的原材料，中央厨房可以及时处理这些材料，减少浪费，同时确保生产出的食品质量不会因原材料变质而受到影响。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                精准采购
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    通过对每日使用量和销售数据的分析，系统能够帮助中央厨房精准预测未来的原材料需求，
                                    从而优化采购计划，避免过度采购或库存不足的情况。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                集中采购优势
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    如果中央厨房为多个门店或项目提供服务，系统可以整合所有需求，进行集中采购，从而获得更具竞争力的价格，进一步降低成本。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "CK_two_column_text"
    }
</script>

<style lang="less">


</style>